"use strict"; // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var _slicedToArray = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Specification = require("../../specification");

var solver_1 = require("../../solver");

var common_1 = require("../common");

var GlyphClass =
/*#__PURE__*/
function (_common_1$ObjectClass) {
  _inherits(GlyphClass, _common_1$ObjectClass);

  function GlyphClass() {
    _classCallCheck(this, GlyphClass);

    return _possibleConstructorReturn(this, _getPrototypeOf(GlyphClass).apply(this, arguments));
  }

  _createClass(GlyphClass, null, [{
    key: "createDefault",
    value: function createDefault(table) {
      var glyph = _get(_getPrototypeOf(GlyphClass), "createDefault", this).call(this);

      glyph.table = table;
      glyph.constraints = [];
      glyph.marks = [];
      return glyph;
    }
  }]);

  return GlyphClass;
}(common_1.ObjectClass);

GlyphClass.metadata = {
  iconPath: "glyph",
  displayName: "Glyph"
};
exports.GlyphClass = GlyphClass;

var RectangleGlyph =
/*#__PURE__*/
function (_GlyphClass) {
  _inherits(RectangleGlyph, _GlyphClass);

  function RectangleGlyph() {
    var _this;

    _classCallCheck(this, RectangleGlyph);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RectangleGlyph).apply(this, arguments)); // Get a list of elemnt attributes

    _this.attributeNames = ["x1", "y1", "x2", "y2", "x", "y", "width", "height", "ix1", "iy1", "ix2", "iy2", "icx", "icy"];
    _this.attributes = {
      x1: {
        name: "x1",
        type: Specification.AttributeType.Number
      },
      y1: {
        name: "y1",
        type: Specification.AttributeType.Number
      },
      x2: {
        name: "x2",
        type: Specification.AttributeType.Number
      },
      y2: {
        name: "y2",
        type: Specification.AttributeType.Number
      },
      x: {
        name: "x",
        type: Specification.AttributeType.Number
      },
      y: {
        name: "y",
        type: Specification.AttributeType.Number
      },
      width: {
        name: "width",
        type: Specification.AttributeType.Number,
        defaultRange: [30, 200]
      },
      height: {
        name: "height",
        type: Specification.AttributeType.Number,
        defaultRange: [30, 200]
      },
      ix1: {
        name: "ix1",
        type: Specification.AttributeType.Number
      },
      iy1: {
        name: "iy1",
        type: Specification.AttributeType.Number
      },
      ix2: {
        name: "ix2",
        type: Specification.AttributeType.Number
      },
      iy2: {
        name: "iy2",
        type: Specification.AttributeType.Number
      },
      icx: {
        name: "icx",
        type: Specification.AttributeType.Number
      },
      icy: {
        name: "icy",
        type: Specification.AttributeType.Number
      }
    };
    return _this;
  } // Initialize the state of a mark so that everything has a valid value


  _createClass(RectangleGlyph, [{
    key: "initializeState",
    value: function initializeState() {
      var attrs = this.state.attributes;
      attrs.x = 0;
      attrs.y = 0;
      attrs.width = 60;
      attrs.height = 100;
      attrs.x1 = attrs.x - attrs.width / 2;
      attrs.y1 = attrs.y - attrs.height / 2;
      attrs.x2 = attrs.x + attrs.width / 2;
      attrs.y2 = attrs.y + attrs.height / 2;
      attrs.ix1 = -attrs.width / 2;
      attrs.iy1 = -attrs.height / 2;
      attrs.ix2 = +attrs.width / 2;
      attrs.iy2 = +attrs.height / 2;
      attrs.icx = 0;
      attrs.icy = 0;
    } // Get intrinsic constraints between attributes (e.g., x2 - x1 = width for rectangles)

  }, {
    key: "buildIntrinsicConstraints",
    value: function buildIntrinsicConstraints(solver) {
      var _solver$attrs = solver.attrs(this.state.attributes, ["x1", "y1", "x2", "y2", "x", "y", "width", "height", "ix1", "iy1", "ix2", "iy2", "icx", "icy"]),
          _solver$attrs2 = _slicedToArray(_solver$attrs, 14),
          x1 = _solver$attrs2[0],
          y1 = _solver$attrs2[1],
          x2 = _solver$attrs2[2],
          y2 = _solver$attrs2[3],
          x = _solver$attrs2[4],
          y = _solver$attrs2[5],
          width = _solver$attrs2[6],
          height = _solver$attrs2[7],
          ix1 = _solver$attrs2[8],
          iy1 = _solver$attrs2[9],
          ix2 = _solver$attrs2[10],
          iy2 = _solver$attrs2[11],
          icx = _solver$attrs2[12],
          icy = _solver$attrs2[13];

      solver.addLinear(solver_1.ConstraintStrength.HARD, 0, [[1, x2], [-1, x1]], [[1, width]]);
      solver.addLinear(solver_1.ConstraintStrength.HARD, 0, [[1, y2], [-1, y1]], [[1, height]]);
      solver.addLinear(solver_1.ConstraintStrength.HARD, 0, [[1, ix2], [-1, ix1]], [[1, width]]);
      solver.addLinear(solver_1.ConstraintStrength.HARD, 0, [[1, iy2], [-1, iy1]], [[1, height]]); // solver.addLinear(ConstraintStrength.HARD, 0, [[2, cx]], [[1, x1], [1, x2]]);
      // solver.addLinear(ConstraintStrength.HARD, 0, [[2, cy]], [[1, y1], [1, y2]]);

      solver.addLinear(solver_1.ConstraintStrength.HARD, 0, [[1, ix1], [1, ix2]]);
      solver.addLinear(solver_1.ConstraintStrength.HARD, 0, [[1, iy1], [1, iy2]]);
      solver.addLinear(solver_1.ConstraintStrength.HARD, 0, [[1, icx]]);
      solver.addLinear(solver_1.ConstraintStrength.HARD, 0, [[1, icy]]);
      solver.addLinear(solver_1.ConstraintStrength.HARD, 0, [[1, x]], [[0.5, x2], [0.5, x1], [1, solver.attr(this.state.marks[0].attributes, "x")]]);
      solver.addLinear(solver_1.ConstraintStrength.HARD, 0, [[1, y]], [[0.5, y2], [0.5, y1], [1, solver.attr(this.state.marks[0].attributes, "y")]]);
    }
  }, {
    key: "getAlignmentGuides",
    value: function getAlignmentGuides() {
      var attrs = this.state.attributes;
      return [{
        type: "x",
        value: attrs.ix1,
        attribute: "ix1",
        visible: true
      }, {
        type: "x",
        value: attrs.ix2,
        attribute: "ix2",
        visible: true
      }, {
        type: "x",
        value: attrs.icx,
        attribute: "icx",
        visible: true
      }, {
        type: "y",
        value: attrs.iy1,
        attribute: "iy1",
        visible: true
      }, {
        type: "y",
        value: attrs.iy2,
        attribute: "iy2",
        visible: true
      }, {
        type: "y",
        value: attrs.icy,
        attribute: "icy",
        visible: true
      }];
    }
  }, {
    key: "getHandles",
    value: function getHandles() {
      var attrs = this.state.attributes;
      var ix1 = attrs.ix1,
          iy1 = attrs.iy1,
          ix2 = attrs.ix2,
          iy2 = attrs.iy2;
      var inf = [-10000, 10000];
      return [{
        type: "line",
        axis: "x",
        actions: [{
          type: "attribute",
          attribute: "ix1"
        }],
        value: ix1,
        span: inf
      }, {
        type: "line",
        axis: "x",
        actions: [{
          type: "attribute",
          attribute: "ix2"
        }],
        value: ix2,
        span: inf
      }, {
        type: "line",
        axis: "y",
        actions: [{
          type: "attribute",
          attribute: "iy1"
        }],
        value: iy1,
        span: inf
      }, {
        type: "line",
        axis: "y",
        actions: [{
          type: "attribute",
          attribute: "iy2"
        }],
        value: iy2,
        span: inf
      }];
    }
  }, {
    key: "getAttributePanelWidgets",
    value: function getAttributePanelWidgets(manager) {
      return [manager.sectionHeader("Dimensions"), manager.mappingEditor("Width", "width", {}), manager.mappingEditor("Height", "height", {})];
    }
  }]);

  return RectangleGlyph;
}(GlyphClass);

RectangleGlyph.classID = "glyph.rectangle";
RectangleGlyph.type = "glyph";

function registerClasses() {
  common_1.ObjectClasses.Register(RectangleGlyph);
}

exports.registerClasses = registerClasses;